<template>
  <sd-modal top="20%" left="33%" v-show="show">
     <div class="form_modal">
        <i class="close"></i>
        <p class="form_title">寄送地址</p>
         <div class="form_ctr" :class="{'invalid':!checkReceiverName && dirty.receiverName}">
             <p class="error">请输入收件人</p>
             <label class="req">收件人</label>
             <input type="text" class="short" v-model="param.receiverName" @blur="dirty.receiverName = true" maxlength="15">
         </div>
         <div class="form_ctr" :class="{'invalid':!checkUserAdd && dirty.userAdd}">
             <p class="error">请输入收件人详细地址</p>
             <label class="req">详细地址</label>
             <textarea v-model="param.userAdd" @blur="dirty.userAdd = true" maxlength="80"></textarea>
         </div>
         <div class="form_ctr" :class="{'invalid':!checkUserPhone && dirty.userPhone}">
             <p class="error">请输入正确的电话号码</p>
             <label class="req">手机号码</label>
             <input type="number" class="short" style="width: 166px;" v-model="param.userPhone" @blur="dirty.userPhone = true" maxlength="13">
         </div>
         <div class="form_ctr" style="margin-top: -10px;">
             <p class="error"></p>
             <input type="checkbox" style="margin-left: 166px;" v-model="param.haveDefault">设为默认
         </div>
         <ul class="btn">
             <li v-if="type=='add'" @click="addAddress">新增</li>
             <li v-if="type=='update'" @click="updateAddress">保存</li>
             <li @click="show = false">返回</li>
         </ul>
    </div>
  </sd-modal>
</template>

<script type="es6">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { util } from '../service/util'
    import sdModal from '../components/sdModal'

    let API = util.api([
        'UPDATEUSERADDRESS',// 更新用户地址
        'ADDUSERADDRESS',// 新增地址
        'UPDATEUSERADDRESS'// 更新地址
      ])
    export default {
        name:'add-address',
        props: ['address'],
        components: { sdModal },
        data () {
            return {
                show: false,
                type: '',
                param: {
                  receiverName: '', // 名称
                  userAdd: '',      // 地址
                  userPhone: '',    // 电话
                  haveDefault: ''   // 默认
                },
                dirty: {
                  receiverName: '',
                  userAdd: '',
                  userPhone: '',
                },
                // 父级的原始数据
                pParam: {}
            }
        },
        computed: {
          _haveDefault() {
            return this.param.haveDefault == 2;
          },
          checkReceiverName() {
            return this.param.receiverName;
          },
          checkUserAdd() {
            return this.param.userAdd;
          },
          checkUserPhone() {
            return this.param.userPhone && this.param.userPhone.length >= 6 && this.param.userPhone.length <= 11;
          },
          checkAll() {
            return this.checkReceiverName && this.checkUserAdd && this.checkUserPhone;
          }
        },
        methods: {
          init() {
            Object.assign(this.$data, this.$options.data());
          },
          doUpdate(address) {
            this.show = true;

            // 操作的类型
            this.type = 'update';
            // 记录父级的原始数据
            // this.pParam = address;
            // 拷贝数据
            let obj = util.copy(address);
            obj.haveDefault = obj.haveDefault == 2 ? true : false;
            this.param = obj;
          },
          doAdd() {
            this.init();
            this.show = true;
            this.type = 'add';
          },
          // 更新父级原始数据
          updateOriginal() {
            for(var key in this.param){
              this.pParam[key] = this.param[key];
            }
            this.pParam.haveDefault = this.pParam.haveDefault === true ? 2 : 1;
          },
          dirtyAll() {
            for(let key in this.dirty){
              this.dirty[key] = true;
            }
          },
          // 新增
          addAddress() {
            this.dirtyAll();
            if(!this.checkAll){
              return;
            }

            let param = util.copy(this.param);
            if(param.haveDefault === true){
              param.haveDefault = 2;
            } else {
              param.haveDefault = 1;
            }
            util.kAjax(API.ADDUSERADDRESS, param, res => {
              // 关闭
              this.show = false;
              // 触发外部事件
              this.$emit('on-success');
              this.init();
              // util.confirm.success('新增地址成功！');
            })
          },
          // 更新
          updateAddress() {
            this.dirtyAll();
            if(!this.checkAll){
              return;
            }

            let param = util.copy(this.param);
            if(param.haveDefault === true){
              param.haveDefault = 2;
            } else {
              param.haveDefault = 1;
            }
            util.kAjax(API.UPDATEUSERADDRESS, param, res => {
              // 更新成功，更新原生数据，清空当前数据
              this.show = false;
              this.$emit('on-success');
              this.init();
              util.confirm.success('更新地址成功！');
            })
          },
        },
        watch: {

        },
        created() {

        }
    }
</script>

<style lang="scss" scoped="">
  .error{
    visibility: hidden;
  }
</style>



// WEBPACK FOOTER //
// addAddress.vue?e1c4313e